import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { PropTypes } from '@micromag/core';
import { getStyleFromBox } from '@micromag/core/utils';
import Text from '@micromag/element-text';

var styles = {"container":"micromag-element-badge-container"};

var propTypes = {
  label: PropTypes.textElement,
  boxStyle: PropTypes.boxStyle,
  className: PropTypes$1.string,
  labelClassName: PropTypes$1.string
};
var defaultProps = {
  label: null,
  boxStyle: null,
  className: null,
  labelClassName: null
};
function Badge(_ref) {
  var label = _ref.label,
    boxStyle = _ref.boxStyle,
    className = _ref.className,
    labelClassName = _ref.labelClassName;
  var _ref2 = label || {},
    _ref2$textStyle = _ref2.textStyle,
    textStyle = _ref2$textStyle === void 0 ? null : _ref2$textStyle;
  var _ref3 = textStyle || {},
    _ref3$lineHeight = _ref3.lineHeight,
    lineHeight = _ref3$lineHeight === void 0 ? null : _ref3$lineHeight;
  var boxStyles = null;
  if (boxStyle !== null) {
    boxStyles = _objectSpread(_objectSpread({}, boxStyles), getStyleFromBox(boxStyle));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: boxStyles
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames([styles.label, _defineProperty({}, labelClassName, labelClassName !== null)])
  }, /*#__PURE__*/React.createElement(Text, Object.assign({}, label, {
    textStyle: _objectSpread(_objectSpread({}, textStyle), {}, {
      lineHeight: lineHeight || 1
    }),
    inline: true
  }))));
}
Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

export { Badge as default };
